var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTradingChips',{attrs:{"symbol":_vm.symbol.symbol,"label":_vm.symbol.alias},on:{"close":function($event){return _vm.closeSymbol(_vm.symbol.id)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }